<template>
  <div style="background: #fff">
    <div class="aui-book-head" v-if="title">
      <h2>{{title}}</h2>
       <span  v-if="showMore"  @click="showMoreAction" class="more">更多</span>
    </div>
    <div class="pull-down-list">
      <router-link  :to="{name: 'book-home', params: {id: book.bookId || book.id}}"  v-for="book in books" :key="book.bookId || book.id" class="pull-down-item">
        <div class="pull-down-img">
          <!-- <img :src="book.cover || book.verticalCover | getImgUrl" alt /> -->
          <img :imgpath="getCoverPlaceholder(book.cover || book.verticalCover)"  v-lazy="require('../../assets/img/loading.jpeg')" alt />

        </div>
        <div class="pull-down-content">
          <h3>
            {{book.title}}
            <span class="i-b">{{book.recommend/10}}分</span>
          </h3>
          <p>{{book.abstractContent}}</p>
          <div class="pull-down-foot">
            <span class="list-author">{{book.categoryName}}</span>
            <span :class="{'finish': book.publishStatus === 'finish', 'in-write': book.publishStatus ==='serialize'}" >{{book.publishStatus | bookStatus}}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getImg } from '../../services/urlService'

export default {
  name: 'books-large',
  props: {
    title: String,
    books: Array,
    showTitle: {
      type: Boolean,
      default: true
    },
    showMore: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  methods: {
    showMoreAction () {
      this.$emit('show-more')
    },
    toBookDetail (id) {
      this.$router.isBack = false
      this.$router.push(`/book/${id}`)
    },
    getCover (route) {
      return getImg(`${route}_200_0.img`)
    },
    getCoverPlaceholder(route) {
      return `${route}_200_0.img`;
    },
    getPublishStatusText (code) {
      if (code === 'finish') {
        return '完结'
      } else {
        return '连载'
      }
    }
  },
  watch: {
    books (data) {}
  }
}
</script>

<style scoped>
.book-tag {
  bottom: 1.2rem !important;
}
</style>
